export var adaptOnChange = function adaptOnChange(onChange, name) {
  return function (event, data) {
    return onChange({
      name: name,
      value: data.value
    });
  };
};